import React, { useState } from 'react';
import { Redirect } from "react-router-dom";

const LobbyIntroVideo = () => {
  const [videoEnded, setVideoEnded] = useState(false)

  const onVideoEnd = () => {
    setVideoEnded(true)
  }

  if(videoEnded) {
    return <Redirect to="/lobby" />
  }

  return (
    <video
      onEnded={() => onVideoEnd()}
      autoPlay
      muted
      className="w-100 d-block"
      src="https://businessexpoapi-stg.greenkosovo.com/Videos/Companies/637424706841003260.mp4"
    />
  )
}

export default LobbyIntroVideo;